/**
 * On-Call rotations (FEAT-051) — DataTableMD column + add-form config.
 *
 * Each column drives BOTH the list column (`showColumn`) and the "Add rotation" modal
 * (`showAdd`). The backend enriches each row at read time with `currentOnCallName` (who is on
 * call now) via OnCallService. Members are chosen as an apiSelect of the school's responders
 * (array of user ids on the wire — matches the incident `assignedUsers` shape).
 */

export const getOnCallColumns = async () => {
  return [
    {
      field: "name",
      headerName: "Rotation Name",
      cellType: "text",
      type: "text",
      dataType: "string",
      required: true,
      showColumn: true,
      showAdd: true,
    },
    {
      // Only super/district admins pick a school; school admins are auto-scoped to their own
      // (dataTableHeader seeds `school = user.school` for non-super/district admins).
      field: "school",
      headerName: "School",
      cellType: "text",
      type: "apiSelect",
      dataType: "string",
      required: true,
      showColumn: false,
      showAdd: true,
      showPermissions: ["disclosureAdmin", "districtAdmin"],
      apiConfig: {
        apiBody: {},
        label: "School",
        dataType: "schools",
      },
    },
    {
      field: "members",
      headerName: "Responders (in rotation order)",
      cellType: "text",
      type: "apiSelect",
      dataType: "list",
      multiple: true,
      required: true,
      showColumn: false,
      showAdd: true,
      labelField: "memberNames",
      apiConfig: {
        apiBody: {
          filters: [
            { key: "permission", value: "responder", expression: "=" },
            { key: "school", value: "{school}", expression: "=", valueObj: "filterValues" },
          ],
        },
        label: "Responders",
        dataType: "users",
      },
      requires: { school: {} },
    },
    {
      field: "schoolName",
      headerName: "School",
      cellType: "text",
      showColumn: true,
      showAdd: false,
    },
    {
      field: "purpose",
      headerName: "Purpose",
      cellType: "text",
      type: "select",
      dataType: "string",
      showColumn: true,
      showAdd: true,
      addDefaultValue: "primary",
      options: [
        { label: "Primary (auto-assign)", value: "primary" },
        { label: "Escalation", value: "escalation" },
        { label: "Secondary", value: "secondary" },
      ],
    },
    {
      field: "rotationLengthDays",
      headerName: "Rotation Cadence",
      cellType: "text",
      type: "select",
      dataType: "string",
      showColumn: true,
      showAdd: true,
      addDefaultValue: "7",
      options: [
        { label: "Weekly (7 days)", value: "7" },
        { label: "Daily", value: "1" },
        { label: "Biweekly (14 days)", value: "14" },
      ],
    },
    {
      field: "handoffTime",
      headerName: "Handoff Time",
      cellType: "text",
      type: "text",
      dataType: "time",
      showColumn: false,
      showAdd: true,
      addDefaultValue: "08:00",
    },
    {
      field: "anchorDate",
      headerName: "Rotation Start Date",
      cellType: "text",
      type: "text",
      dataType: "date",
      required: true,
      showColumn: false,
      showAdd: true,
    },
    {
      field: "timezone",
      headerName: "Timezone (IANA)",
      cellType: "text",
      type: "text",
      dataType: "string",
      showColumn: false,
      showAdd: true,
      addDefaultValue: "America/New_York",
    },
    {
      field: "isDefaultAssignment",
      headerName: "Auto-assign new incidents here?",
      cellType: "text",
      type: "select",
      dataType: "string",
      showColumn: true,
      showAdd: true,
      addDefaultValue: "False",
      options: [
        { label: "Yes — primary rotation", value: "True" },
        { label: "No", value: "False" },
      ],
    },
    {
      field: "currentOnCallName",
      headerName: "On Call Now",
      cellType: "text",
      showColumn: true,
      showAdd: false,
    },
  ];
};

export const getOnCallFilters = async () => [];
